import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useSuccessStore = defineStore('success', () => {
  const success = ref<string[]>([])

  const getSuccess = computed(() => success.value)
  const hasSuccess = computed(() => success.value.length > 0)

  function setSuccess(newMessages: string[]) {
    success.value = newMessages
  }
  function clearSuccess() {
    success.value = []
  }
  function removeSuccess(index: number) {
    success.value.splice(index, 1)
  }

  return { getSuccess, hasSuccess, setSuccess, clearSuccess, removeSuccess }
})
